<template>
  <div class="activation-component-container">
    <div
      v-for="activator in activators"
      :key="activator.id"
      class="activator"
    >
      <component
        :is="activator.activatorType"
        :activator="activator"
        :mastery="mastery"
        :show-expander-button="showExpanderButton"
      />
    </div>
  </div>
</template>

<script>
import ActivationMixin from '@/mixins/activation';
import Ase from '@components/activation/types/ase';
import IowaDot from '@components/activation/types/iowaDot';
import LicenseCode from '@components/activation/types/licenseCode';
import LicenseCodeSpringerSpecial from '@components/activation/types/licenseCode';

export default {
  components: { Ase, IowaDot, LicenseCode, LicenseCodeSpringerSpecial },
  mixins: [ActivationMixin],
  props: {
    activators: {
      type: Array,
      default: () => [],
    },
    mastery: {
      type: Boolean,
      default: false,
    },
    showExpanderButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang='scss' scoped>
.activation-component-container {
  .activator {
    display: flex;

    > div {
      flex: 1;
    }
  }
}
</style>
